import {
  SectionWrapper,
  UnderHeader,
} from 'components/atoms/SectionWrapper.style';
import React from 'react';
import FarmImages from 'components/organisms/farmsComponents/farmImages/OfferImages';
import FarmDesc from 'components/organisms/farmsComponents/farmDesc/FarmDesc';
import Header from 'components/organisms/header/Header';
import EleHeader from 'components/organisms/header/EleHeader';
import EleOfferImages from 'components/organisms/electroComponents/eleOfferImg/EleOfferImg';
import EleFarmDesc from 'components/organisms/electroComponents/eleFarmDesc/EleFarmDesc';
import OzeHeader from 'components/organisms/header/OzeHeader';
import OzeOfferImages from 'components/organisms/ozeCompontents/OzeOfferImg/OzeOfferImg';
import OzeFarmDesc from 'components/organisms/ozeCompontents/OzeFarmDesc/OzeFarmDesc';
import OzeCounter from 'components/organisms/ozeCompontents/OzeCounters/OzeWrapper';

const OzeOffer = () => (
  <>
    <OzeHeader />
    <OzeOfferImages />
    {/* <UnderHeader /> */}
    <SectionWrapper>
      <OzeFarmDesc />
    </SectionWrapper>
    <OzeCounter />
  </>
);

export default OzeOffer;
